import { useEffect, useState } from "react";
import {
  Clock,
  Today,
  RoundArrowCircle,
  Clander,
  Exit,
} from "../../../../component/LeadsDashboardComponents/StatCardIcons";
import {
  StatCard,
  StatsCardSkeleton,
} from "../../../../component/LeadsDashboardComponents/StatCard";
import { PipelineChart } from "../../../../component/LeadsDashboardComponents/PipelineChart";
import { CompanyCard } from "../../../../component/LeadsDashboardComponents/CompanyCard";
import { LostLeadsChart } from "../../../../component/LeadsDashboardComponents/LostLeadsChart";
import { LeadsByProduct } from "../../../../component/LeadsDashboardComponents/LeadsByProduct";
import { RecentLeadsTable } from "../../../../component/LeadsDashboardComponents/RecentLeadsTable";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Skeleton } from "@mui/material";
import { LeadsBySource } from "../../../../component/LeadsDashboardComponents/LeadsBySource";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import LeadsByBrands from "../../../../component/LeadsDashboardComponents/LeadsByBrands";
import LeadsEngagement from "../../../../component/LeadsDashboardComponents/LeadEngagement";
import { CircleAlert } from "lucide-react";
import momentZone from "moment-timezone";
import LeadsConversion from "../../../../component/LeadsDashboardComponents/LeadConversion";
import { TodayFollowups } from "../../../../component/LeadsDashboardComponents/TodayFollowUps";
import { LeadsByStageChart } from "../../../../component/LeadsDashboardComponents/LeadsByStageChart";
import DateTime from "../../../../component/DateTime";

const View = "myteam";

export default function LeadsOrgOverviewNew() {
  // const [dateRange] = useState('11/02/2026 - 11/02/2026');
  const [brandFilter, setBrandFilter] = useState("this_month");

  const apiCall = useApiCall();

  // KPIS
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const getKPIData = async () => {
    setKPILoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/lead-overview-kpi-2?view=${View}&time=${brandFilter}`,
      });
      setKPIData(resp?.data);
      setKPILoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const [followUpsData, setfollowUpsData] = useState([]);
  const [followUpsApiLoading, setFollowUpsApiLoading] = useState(false);

  const getFollowUpsData = async () => {
    setFollowUpsApiLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `activities/get-dashboard-followups?view=view=${View}&time=${brandFilter}`,
      });
      setfollowUpsData(resp?.data);
      setFollowUpsApiLoading(false);
    } catch (error) {
      setFollowUpsApiLoading(false);
      console.warn("Error : ", error);
    } finally {
      setFollowUpsApiLoading(false);
    }
  };

  // lead by conversion

  const [conversionData, setConversionData] = useState([]);
  const [conversionApiLoading, setConversionApiLoading] = useState(false);

  const getConversionData = async () => {
    setConversionApiLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/leads-conversion-rate?view=${View}&time=${brandFilter}`,
      });
      setConversionData(resp?.data?.monthly_breakdown);
      setConversionApiLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const [overAllData, setOverAllData] = useState({});
  const [overAllLoading, setOverAllLoading] = useState(true);

  const getOverallData = async () => {
    setOverAllLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/lead-pipeline-stages?view=${View}&time=${brandFilter}`,
      });
      setOverAllData(resp);
      setOverAllLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  // console.log("overAllData", overAllData)

  const [sourceData, setSourceData] = useState([]);
  const [sourceDataTotal, setSourceDataTotal] = useState([]);
  const [sourceLoading, setSourceLoading] = useState(false);

  const getLeadsBySourceData = async () => {
    setSourceLoading(false);

    const apiUrl = `leads/lead-by-source?view=${View}&time=${brandFilter}`;

    try {
      const res = await apiCall({ method: "get", url: apiUrl });
      setSourceData(res?.data);
      setSourceDataTotal(res?.total_count);
    } catch (error) {
      console.warn("Error fetching brand data:", error);
    } finally {
      setSourceLoading(true);
    }
  };

  const [statusData, setStatusData] = useState([]);
  const [statusApiLoading, setStatusApiLoading] = useState(false);

  const getStatusData = async () => {
    setStatusApiLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `leads/leads-by-status?view=${View}&time=${brandFilter}`,
      });
      setStatusData(resp?.data);
      setStatusApiLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getStatusData();
    getKPIData();
    getOverallData();
    getLeadsBySourceData();
    getFollowUpsData();
    getConversionData();
  }, [brandFilter]);
  return (
    <div className="w-full h-full overflow-auto p-5 flex flex-col">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-3 gap-4">
        <div>
          <h1 className="text-[24px] font-bold">Team Metrics</h1>
        </div>

        <DateTime />
      </div>

      <div>
        {followUpsData?.overdue_followups > 0 ? (
          <div
            className={`inline-flex items-center gap-1 py-2 px-[18px] rounded-[10px] text-sm font-medium mb-7 transition-all text-[#ff6347] border bg-[rgba(255,99,71,0.15)] border-[rgba(255,99,71,0.3)]`}
          >
            <CircleAlert className="w-[20px] h-[20px]" />
            You have {followUpsData?.overdue_followups} Overdue follow-ups from
            yesterday.
          </div>
        ) : null}
      </div>

      <div className="w-full h-full">
        {/* Header */}
        <div className="mb-6">
          {/* Stat Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-6">
            {!KPILoading ? (
              <>
                <StatCard
                  icon={Clock}
                  iconBgColor="#BBF7D0"
                  iconColor={"#16A34A"}
                  title="Total Lead Pipeline"
                  value={KPIData?.total_leads}
                  progress={40}
                  progressColor="bg-[#84CC16]"
                  subLabel="All Time Count"
                />
                {/* <StatCard
                icon={<UserCheck className="w-5 h-5" />}
                iconBg="bg-blue-500"
                title="New Leads"
                subLabel="Daily Intake"
                value={KPIData?.leads_today}
                progress={40}
                progressColor="bg-blue-500"
                trend={`${KPIData?.lead_today_percentage}%`}
                trendUp={false}
              /> */}
                <StatCard
                  icon={Today}
                  iconColor={"#FF7F50"}
                  iconBgColor="#FFEBE0"
                  title="Leads Acquisition"
                  value={KPIData?.leads_this_month?.count}
                  progress={KPIData?.leads_this_month?.progress}
                  progressColor="bg-[#0095FF]"
                  trend={`${KPIData?.leads_this_month?.percentage}`}
                  trendUp={KPIData?.leads_this_month?.trendup}
                  subLabel="This Month"
                />
                <StatCard
                  icon={RoundArrowCircle}
                  iconColor={"#FF4040"}
                  iconBgColor="#FEE2E2"
                  title="Leads Today"
                  value={KPIData?.leads_today?.count}
                  progress={KPIData?.leads_today?.progress}
                  progressColor="bg-[#BF83FF]"
                  trend={KPIData?.leads_today?.percentage}
                  trendUp={KPIData?.leads_today?.trendup}
                  subLabel="Last 30 days"
                />

                <StatCard
                  icon={Clander}
                  iconColor={"#335CFF"}
                  iconBgColor="#DBEAFE"
                  title="Outstanding Amount"
                  value={`$${KPIData?.expected_amount?.count}`}
                  progress={KPIData?.expected_amount?.progress}
                  progressColor="bg-[#FF7F50]"
                  trend={KPIData?.expected_amount?.percentage}
                  trendUp={KPIData?.expected_amount?.trendup}
                  subLabel="Last 30 days"
                />

                <StatCard
                  icon={Exit}
                  iconBgColor="#EDE9FE"
                  iconColor={"#6D28D9"}
                  title="Leads Converted"
                  subLabel="Conversions (MTD)"
                  value={KPIData?.converted_leads?.count}
                  progress={KPIData?.converted_leads?.progress ?? 40}
                  progressColor="bg-[#0E121B]"
                />

                {/* <StatCard
                icon={<IdCard className="w-5 h-5" />}
                iconBg="bg-red-500"
                title="Active Deals in Pipeline"
                value={KPIData?.deals_in_progress}
                progress={40}
                progressColor="bg-pink-500"
                subLabel="Pipeline Status (MTD)"
              />

              <StatCard
                icon={<FileText className="w-5 h-5" />}
                iconBg="bg-purple-600"
                title="Closed / Lost"
                value={KPIData?.closed_or_lost}
                progress={40}
                progressColor="bg-purple-600"
                subLabel="Recent Outcomes (MTD)"
              /> */}
              </>
            ) : (
              Array.from({ length: 5 }).map((_, index) => <StatsCardSkeleton />)
            )}
          </div>
        </div>

        {/* Charts Row */}
        {/* <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-8 min-h-[410px]">
            <PipelineChart
              view={View}
              pipData={overAllData?.data}
              lineLoading={overAllLoading}
              totalData={overAllData?.totals}
            />
          </div>
          <div className="xl:col-span-8 min-h-[410px]">
            <LeadsEngagement
              view={View}
              pipData={overAllData?.data}
              lineLoading={overAllLoading}
              totalData={overAllData?.totals}
            />
          </div>

        
          <div className="xl:col-span-4 min-h-[410px]">
            <LeadsByBrands
              view={View}
              brandData={overAllData?.brand_stats}
              brandLoading={overAllLoading}
            />
          </div>
        </div> */}

        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-4 min-h-[410px]">
            <LeadsConversion
              view={View}
              pipData={conversionData}
              lineLoading={conversionApiLoading}
              totalData={overAllData?.totals}
            />
          </div>

          <div className="xl:col-span-4 min-h-[410px]">
            <LeadsByStageChart
              statusData={statusData}
              statusApiLoading={statusApiLoading}
            />
          </div>

          <div className="xl:col-span-4 min-h-[410px]">
            <TodayFollowups
              view={View}
              loading={followUpsApiLoading}
              leads={followUpsData?.todays_followup_list}
              count={followUpsData?.todays_followup_count}
            />
          </div>
        </div>

        {/* Second Row */}
        {/* <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-7 min-h-[410px]">
            <LostLeadsChart
              view={View}
              distributionData={KPIData?.lead_by_status}
              distributionLoading={KPILoading}
            />
          </div>

          <div className="xl:col-span-5 min-h-[410px]">
            <LeadsBySource
              sourceData={sourceData}
              sourceDataTotal={sourceDataTotal}
              sourceLoading={sourceLoading}
              view={View}
            />
          </div>
        </div> */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-6 min-h-[410px]">
            <LeadsEngagement
              view={View}
              pipData={overAllData?.data}
              lineLoading={overAllLoading}
              totalData={overAllData?.totals}
            />
          </div>

          <div className="xl:col-span-6 min-h-[410px]">
            <RecentLeadsTable view={View} />
          </div>
        </div>

        {/* Fourth Row */}
        {/* <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
          <div className="xl:col-span-5 h-[520px]">
            <LeadsByProduct
              view={View}
              sourceData={overAllData?.lead_products}
              sourceLoading={overAllLoading}
            />
          </div>
          <div className="xl:col-span-7 h-[520px]">
            <RecentLeadsTable view={View} />
          </div>
        </div> */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
          <div className="xl:col-span-4 h-[520px]">
            <LeadsByProduct
              view={View}
              sourceData={overAllData?.lead_products}
              sourceLoading={overAllLoading}
            />
          </div>

          <div className="xl:col-span-4 h-[520px]">
            <LeadsByBrands
              view={View}
              brandData={overAllData?.brand_stats}
              brandLoading={overAllLoading}
            />
          </div>

          <div className="xl:col-span-4 h-[520px]">
            <LeadsBySource
              sourceData={sourceData}
              sourceDataTotal={sourceDataTotal}
              sourceLoading={sourceLoading}
              view={View}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
